import { app } from '../../../../../bootstrap/core';
import { receivingConfirmRequestState, receivingConfirmRequestStateName } from './confirmRequest.state';
import { receivingConfirmRequestComponent } from './confirmRequest.component';
import { ConfirmReceivingService } from './confirmRequest.service';

app.config(receivingConfirmRequestState);
app.constant('receivingConfirmRequestStateName', receivingConfirmRequestStateName);
app.component(receivingConfirmRequestComponent.name, receivingConfirmRequestComponent);
app.service('confirmReceivingService', ConfirmReceivingService);
